export const MIN_WEIGHT = 1;
export const MAX_WEIGHT = 100;

export const HEADER_CELLS = [
  { title: 'Reviewer ID' },
  { title: 'Name' },
  { title: 'Weight' },
  { title: 'On leave' },
];
